import { SystemIcon } from "@justworkshr/milo-icons";

export const documentIcon = (
  <SystemIcon iconName="document" color="brand" size="small" />
);
